import * as keyapis_telemetry_metric_v1_events_pb from "./v1/keyapis_telemetry_metric_events_v1.pb";
import * as keyapis_telemetry_metric_v1_measurement_pb from "./v1/keyapis_telemetry_metric_measurement_v1.pb";
import * as keyapis_telemetry_metric_v1_system_pb from "./v1/keyapis_telemetry_metric_system_v1.pb";

export default {
  v1: {
    resources: {
      events: keyapis_telemetry_metric_v1_events_pb,
      measurement: keyapis_telemetry_metric_v1_measurement_pb,
      system: keyapis_telemetry_metric_v1_system_pb,
    },
  },
};
